module.exports = __webpack_public_path__ + "static/moodboard-app-mobile-plp-c0a6e102b765bced40e6d7df3319576a.png";